module.exports = __webpack_public_path__ + "img/imac_design.a4ae23a6.jpg";